<template>
  <i class="tm-overlay" v-tm-move="moveObj" @dblclick="$_editOverlay">
    <tm-overlay-menu
      :overlay="$props.overlay"
      :pipa="$props.pipa"
      :isSelected="isSelected"
      :overlayRectangles="overlayRectangles"
      :hoveredRectangle="$data.hoveredRectangle"
    />

    <tm-overlay-span
      v-for="(rectangle, i) in overlayRectangles"
      :key="i"
      :rectangle="rectangle"
      :isFirst="i === 0"
      :isLast="i === overlayRectangles.length - 1"
      :overlay="$props.overlay"
      @hoveredOverlay="$_onHoverOverlay"
      :isHovered="$data.isHovered"
      :isSelected="isSelected"
      :isSceneEdit="$props.isSceneEdit"
      :borderMode="borderMode"
    />

    <tm-overlay-resize
      :visible="showResize"
      :fromLeft="true"
      :rectangle="overlayRectangles[0]"
      :overlay="$props.overlay"
      :pipa="$props.pipa"
      :isOverlayResizing.sync="isOverlayResizing"
      @hoveredOverlay="$_onHoverOverlay"
    />

    <tm-overlay-resize
      :visible="showResize"
      :fromRight="true"
      :rectangle="overlayRectangles[overlayRectangles.length - 1]"
      :overlay="$props.overlay"
      :pipa="$props.pipa"
      :isOverlayResizing.sync="isOverlayResizing"
      @hoveredOverlay="$_onHoverOverlay"
    />
  </i>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { OverlayBorderMode } from '../../../../api/model';
import gridMixin from '../../../grid.mixin';
import moveVisualOverlayMixin from '../../../movable/moveVisualOverlay';
import tmOverlaySpan from './tmOverlaySpan.vue';
import tmOverlayResize from './tmOverlayResize.vue';
import tmOverlayMenu from '../../../menu/tmOverlayMenu.vue';
import tmMove from '../../../movable/tmMove';
import _ from 'lodash-extended';
import tmBus from '../../../../api/tmBus';

export default {
  name: 'tm-overlay',
  mixins: [gridMixin, moveVisualOverlayMixin],
  directives: { tmMove },
  components: {
    tmOverlayMenu,
    tmOverlaySpan,
    tmOverlayResize,
  },

  props: {
    pipa: { type: Object, required: true },
    overlay: { type: Object, required: true },
    isSceneEdit: { type: Boolean, required: true },
  },

  data() {
    return {
      overlayRectanglesCache: [],
      hoveredRectangle: null,
      isHovered: false,
      isOverlayResizing: false,
    };
  },

  computed: {
    ...mapState('timemachine', {
      overlay2replace: (state) => state.dndEscort.overlay2replace,
      selectedOverlay: (state) => state.selected.overlay,
      MODE_OVERLAY_DND: (state) => state.MODE.OVERLAY_DND,
      trackLayerVisual: (state) => state.trackLayer.visual,
    }),

    overlayRectangles() {
      if (this.gridEstablished) {
        return this.$_time2rectangles(
          this.$props.pipa.toAbsolute(this.$props.overlay.displayStartTime),
          this.$props.pipa.toAbsolute(this.$props.overlay.displayEndTime),
          true
        );
      } else {
        // while initializing grid - keep using old coordinates
        return this.$data.overlayRectanglesCache;
      }
    },

    showResize() {
      return (
        this.$props.isSceneEdit &&
        this.$data.isHovered &&
        !this.MODE_OVERLAY_DND
      );
    },

    isTargetForReplace() {
      return this.overlay2replace?.guid === this.$props.overlay.guid;
    },

    isSelected() {
      return this.selectedOverlay?.guid === this.$props.overlay.guid;
    },

    borderMode() {
      if (this.$props.isSceneEdit) {
        if (this.isTargetForReplace) {
          return OverlayBorderMode.REPLACE;
        } else if (this.isSelected) {
          return OverlayBorderMode.SELECTED;
        }
      } else {
        if (!this.$data.isHovered) {
          return OverlayBorderMode.PASSIVE;
        }
      }
      return OverlayBorderMode.DEFAULT;
    },
  },

  watch: {
    overlayRectangles: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$data.overlayRectanglesCache = value;
          this.$data.hoveredRectangle = value[0];
        }
      },
    },
  },

  methods: {
    ...mapActions('timemachine', ['SCENE_EDIT_MODE_APPLY']),

    $_onHoverOverlay(hovered, rectangle) {
      this.$data.isHovered = hovered;
      this.$emit('hoveredOverlay', hovered, rectangle);
      if (hovered) {
        this.$data.hoveredRectangle = rectangle;
      }
    },

    $_editOverlay: _.debounce(
      function (e) {
        e.stopPropagation();

        this.SCENE_EDIT_MODE_APPLY({ keepItSelected: false }).then(
          ({ sceneTrack }) => {
            tmBus.$emit('callbackApplySceneEdit', {
              e,
              asset: sceneTrack.data,
              analyticsData: { confirm: 'v', using: 'dblclick' },
            });
            tmBus.$emit('callbackEditAsset', {
              asset: sceneTrack.data,
              overlayGuid: this.$props.overlay.guid,
            });
          }
        );
      },
      256,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss">
.tm-visual > .tm-overlay {
  cursor: grab;
}
</style>
